// extracted by mini-css-extract-plugin
export default {"palette":"palette_b56e6b51c1f291d9a283","button":"button_a7d2df2af6163de5b4a2"};